import { Box, Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { OrderHelpRequest } from 'features/OrderHelpRequest';
import { DialogBoxContent } from 'shared/ui/DialogBoxContent/DialogBoxContent';

import { SupplierDetails } from './SupplierDetails';

interface MiddleManModalProps {
    open: boolean;
    onClose: () => void;
}

export const MiddleManModal = ({ open, onClose }: MiddleManModalProps) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: '1000px',
                    minWidth: '800px',
                    width: '100%',
                },
            }}
            data-testid="modal-help-with-order"
        >
            <DialogBoxContent
                title={t('Help with order')}
                onClose={onClose}
                titleSx={{ px: '12px' }}
                contentSx={{ padding: '0 12px' }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 3,
                    }}
                >
                    <Box sx={{ width: '60%' }}>
                        <OrderHelpRequest />
                    </Box>
                    <Box sx={{ width: '40%' }}>
                        <SupplierDetails />
                    </Box>
                </Box>
            </DialogBoxContent>
        </Dialog>
    );
};
